export default {  
    SET_USERINROLES: (state, payload) => state.userInRoles = payload,
  }